import React from 'react';

const ProjectsPageFun = () => (
  <div className="page-content">
    <a className="fun" target="_blank" href="/img/mspaint.jpg" rel="noopener noreferrer">
      <img src="/img/mspaint.jpg" alt="MS Paint Rocks!" />
      <p>MS Paint Rocks!</p>
    </a>
    <a className="fun" target="_blank" href="/img/halloween.jpg" rel="noopener noreferrer">
      <img src="/img/halloween.jpg" alt="halloween" />
      <p>Halloween</p>
    </a>
    <a className="fun" target="_blank" href="/img/dragon-tiger.jpg" rel="noopener noreferrer">
      <img src="/img/dragon-tiger.jpg" alt="Dragon/Tiger" />
      <p>Very old Logo</p>
    </a>
    <a className="fun" target="_blank" href="/img/lighthouse-comic.jpg" rel="noopener noreferrer">
      <img src="/img/lighthouse-comic.jpg" alt="Lighthouse Labs Comic" />
      <p>Lighthouse Labs Jan cohort 2016 comic!</p>
    </a>
    <a className="fun" target="_blank" href="/img/ying-yang.svg" rel="noopener noreferrer">
      <img src="/img/ying-yang.svg" alt="Ying Yang svg" />
      <p>Ying Yang Svg</p>
    </a>
  </div>
);

export default ProjectsPageFun;
